class PageNotFound {
    initAnimation(totalCount, animatedCount) {
        $('.page-404__board-sticker').one('mouseover', function() {
            $(this).addClass('page-404__board-sticker--animation-' + WG.utils.getRandomInt(1, 3));
            animatedCount += 1;
            if (animatedCount >= totalCount) {
                setTimeout(function() {
                    $('.page-404__ufo').addClass('page-404__ufo--animated');
                }, 5000);
            }
        });
    }

    initStickers(totalCount) {
        setTimeout(function() {
            $('.page-404__board-sticker')
                .eq(totalCount - 2)
                .addClass('page-404__board-sticker--animation-1');
        }, 2000);
        setTimeout(function() {
            $('.page-404__board-sticker')
                .eq(totalCount - 1)
                .addClass('page-404__board-sticker--animation-2');
        }, 3600);
    }

    init() {
        const animatedCount = 2;
        const totalCount = $('.page-404__board-sticker').length;

        if (window.isMobile.mobile) {
            $('.page-404').addClass('mobile');
        } else if (window.isMobile.tablet) {
            $('.page-404').addClass('tablet');
        } else {
            $('.page-404').addClass('desktop');
        }

        this.initStickers(totalCount);
        this.initAnimation(totalCount, animatedCount);
    }
}

$(function() {
    const pageNotFound = new PageNotFound();

    pageNotFound.init();
});



// WEBPACK FOOTER //
// ./assets/js/projects/404/404.js